import type { GetAddressCommentsQuery } from '@schema/cart';
import type { PrepareAllCommentsOptionsReturnType } from './prepareAllCommentsOptions';

type PrepareAddressCommentsArgs = PrepareAllCommentsOptionsReturnType & {
  items: NonNullable<
    GetAddressCommentsQuery['getAddressComments']
  >['commentItems'];
};

export type PrepareAddressCommentsReturnType = Omit<
  PrepareAllCommentsOptionsReturnType,
  'orderChange' | 'orderHome' | 'orderOptions'
> & {
  orderChange?:
    | (PrepareAllCommentsOptionsReturnType['orderChange'] & {
        value: string | null | undefined;
      })
    | undefined;
  orderHome?:
    | (PrepareAllCommentsOptionsReturnType['orderHome'] & {
        value: boolean;
      })
    | undefined;
};

const prepareAddressComments = ({
  items,
  selects,
  checkboxes,
  orderChange,
  orderHome
}: PrepareAddressCommentsArgs): PrepareAddressCommentsReturnType => {
  const newState: PrepareAddressCommentsReturnType = {
    checkboxes,
    selects,
    orderChange: orderChange
      ? { ...orderChange, value: orderChange.value ?? '' }
      : undefined,
    orderHome: orderHome
      ? { ...orderHome, value: orderHome.value ?? false }
      : undefined
  };
  items?.forEach(item => {
    if (item?.comment?.id === 16) {
      newState.orderChange = {
        ...orderChange,
        value: item?.value || ''
      };
    } else if (item?.comment?.id === 37) {
      newState.orderHome = {
        ...orderHome,
        value: item?.value === '1'
      };
    } else if (item?.comment?.type === 'checkbox') {
      newState.checkboxes = newState.checkboxes.map(i => {
        if (item?.comment?.id === i.id) {
          return {
            ...i,
            value: item?.value === '1'
          };
        }
        return i;
      });
    } else if (item?.comment?.type === 'select') {
      newState.selects = newState.selects.map(i => {
        if (item.comment?.id === i?.id) {
          return {
            ...i,
            value: item.option?.id
          };
        }
        return i;
      });
    }
  });

  return newState;
};

export default prepareAddressComments;
